/* All products remain visible without JavaScript. Filtering changes no prices or order. */
if (!customElements.get('nr-golf-collection')) {
  customElements.define('nr-golf-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.onFilterClick) return;
      const filters = this.querySelector('[data-filters]');
      const count = this.querySelector('[data-net-count]');
      const cards = Array.from(this.querySelectorAll('[data-net-card]'));
      if (!filters || !count || !cards.length) return;
      this.onFilterClick = (event) => {
        const button = event.target.closest('[data-width-filter]');
        if (!button || !filters.contains(button)) return;
        const group = button.dataset.widthFilter;
        let visible = 0;
        cards.forEach((card) => {
          card.hidden = group !== 'all' && card.dataset.widthGroup !== group;
          if (!card.hidden) visible += 1;
        });
        filters.querySelectorAll('[data-width-filter]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        count.textContent = `${visible} ${this.dataset.countLabel || ''}`.trim();
      };
      filters.addEventListener('click', this.onFilterClick);
      filters.hidden = false;
    }
    disconnectedCallback() {
      this.querySelector('[data-filters]')?.removeEventListener('click', this.onFilterClick);
      this.onFilterClick = null;
    }
  });
}
